import dayjs from "dayjs";
import { action, observable } from "mobx";
import moment from "moment";
import { isDevelopment } from "../../env";
import { YYYYMMDD, YYYYMMDDHHmmss } from "../../utils/time.utils";
var makeClockController = function () {
    var c = observable({
        localNowMoment: moment(),
        localNowDayjs: dayjs(),
        localNow: dayjs().toDate().getTime(),
        get nowUtcTimestamp() {
            return dayjs(c.localNowDayjs).utc().format(YYYYMMDDHHmmss);
        },
        get todayUtcDate() {
            return dayjs(c.localNowDayjs).utc().format(YYYYMMDD);
        },
        get todayLocalDate() {
            return dayjs(c.localNowDayjs).format(YYYYMMDD);
        },
    });
    setInterval(action(function () {
        c.localNowMoment = moment();
        c.localNowDayjs = dayjs();
        c.localNow = c.localNowDayjs.toDate().getTime();
    }), 1000);
    return c;
};
export var CLOCK = makeClockController();
// @ts-ignore
if (isDevelopment)
    window.CLOCK = CLOCK;
